import { Component, ElementRef, Renderer2, AfterViewInit } from "@angular/core";
import { Subscription } from "rxjs";
import { NavigationService } from "../app/sk-services/navigation.service";

@Component({
  selector: "sk-app",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements AfterViewInit {
  darkbgColor: string = "#121111";
  modern: string = "#233554";
  vintage: string = "rgb(242 242 242)";
  darkBgImage: string = "url('./assets/images/background_1.jpg')";
  modernBgImage: string = "url('./assets/images/background_2.jpg')";
  vintageBgImage: string = "url('./assets/images/background_3.jpg')";

  subscription: Subscription;
  currentView: string = "home";
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private navigationService: NavigationService
  ) {
    this.subscription = this.navigationService
      .getCurrentNavigation()
      .subscribe((currentView) => {
        if (currentView) {
          this.currentView = currentView;
        }
      });
  }

  ngAfterViewInit() {
    this.onModern();
  }

  onVintage() {
    this.renderer.addClass(this.elementRef.nativeElement, "vintage");
    this.renderer.removeClass(this.elementRef.nativeElement, "modern");
    this.renderer.removeClass(this.elementRef.nativeElement, "no-color");
    this.changeBodyBackground(this.vintage);
  }

  onModern() {
    this.renderer.removeClass(this.elementRef.nativeElement, "vintage");
    this.renderer.addClass(this.elementRef.nativeElement, "modern");
    this.renderer.removeClass(this.elementRef.nativeElement, "no-color");
    this.changeBodyBackground(this.modern);
  }

  onNoColor() {
    this.renderer.removeClass(this.elementRef.nativeElement, "vintage");
    this.renderer.removeClass(this.elementRef.nativeElement, "modern");
    this.renderer.addClass(this.elementRef.nativeElement, "no-color");
    this.changeBodyBackground(this.darkbgColor);
  }

  changeBodyBackground(bgColor, bgImage = null) {
    let bodyElement = document.getElementsByTagName("body");
    bodyElement[0].style.backgroundColor = bgColor;
    if (bgImage) {
      bodyElement[0].style.backgroundImage = bgImage;
    }
  }
}
